export default __webpack_public_path__ + "static/media/turkey_dark_male.d1d9fdaf.png";